/**
 * Event fired when datagrid settings are updated.
 *
 * Purpose: Notifies listeners when datagrid configuration changes occur
 * Emitter: DataGrid settings components when user modifies settings
 * Listeners: usePresets hook to update virtual preset state when settings change
 */
export const SETTINGS_UPDATED_EVENT = 'datagrid:settingsUpdated';
